import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Carousel from "../../Carousel";
import About from "../About";
import Portfolio from "../../Portfolio";
import BloodDonation from "../../BloodDonation";
import MissionSection from "../../Mission";
import Service from "../../Service";
import Testimonials from "../../Testimonials";
import RecoverySection from "../../Recovery";
import { counters } from "../../Constants/Counters";

const Home = () => {
  const bannersItems = [
    {
      img: "assets/img/m-home/S-2.jpg",
      // title: "At vero eos et accusamus",
      // description:
      //   "Nam libero tempore, cum soluta  est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut.",
    },
    {
      img: "assets/img/m-home/S-3.jpg",
      // title: "Title 4",
      // description: "Description for image 4.",
    },
  ];

  const services = [
    {
      label: "Zero Wastage Food",
      img: "Zero_Wastage_Food.png",
      link: "/zero-wastage-food",
      totalDescription: "Total 33099+ PLATES SHARED WITH LOVE",
    },
    {
      label: "Khusi Ferao",
      img: "Khusi_Ferao.png",
      link: "/khushi-ferao",
      totalDescription: "Total 17964+ Benefited Peopels",
    },
    {
      label: "Education Help",
      img: "Education_Help.png",
      link: "/education-help",
      totalDescription: "Total 2844+ students benefited",
    },
    {
      label: "Free Oxygen Service",
      img: "Oxygen.png",
      link: "/zero-wastage-food",
      totalDescription: "Total 83+ benefited Peoples",
    },
    {
      label: "DBD Service",
      img: "DBD.png",
      link: "/dbd",
      totalDescription: "Total 1131+ benefited Peoples",
    },
    {
      label: "Ambulance Service",
      img: "Ambulance_Service.png",
      link: "/zero-wastage-food",
      totalDescription: "Total 91+ benefited Patient",
    },
    {
      label: "Bina Paysar Bazar",
      img: "Bina_Paysar_Bazar.png",
      link: "/bina-paysar-bazar",
      totalDescription: "Total 3161+ benefited Peoples",
    },
    {
      label: "Nature Bachao",
      img: "Nature_Bachao.png",
      link: "/nature-bachao",
      totalDescription: "Total 316+ Plantation",
    },
    {
      label: "Sanitary Napkin Service",
      img: "Sanitary_Napkin.png",
      link: "/free-napkin",
      totalDescription: "Total 255+ Women benefited",
    },
    {
      label: "Covid 19 Service",
      img: "Covid.png",
      link: "/covid-service",
      totalDescription: "Total 57945+ benefited Peoples",
    },
  ];

  const shareYourHands = [
    {
      label: "DONATE US",
      img: "DONATION.png",
      link: "/donate-us",
      totalDescription:
        "We make a living by what we get,but we make a life by what we give.",
      backgroundColor: "#cadb2a",
    },
    {
      label: "JOIN AS VOLUNTEER",
      img: "VOLUNTEER.png",
      link: "/apply-member",
      backgroundColor: "#bed9cc",
      totalDescription:
        "View this as your social responsibility to support those less privileged.",
    },
    {
      label: "DIRECT BLOOD DONOR",
      img: "BLOOD-DONATION.png",
      link: "/apply-dbd",
      backgroundColor: "	#F4C430",
      totalDescription:
        "Become a member of DBD group and get a chance to save others life.",
    },
  ];

  const portfolioImage = [
    {
      img: "assets/img/m-home/G-1.jpg",
      title: "Nourishing Hope: Volunteers Serving Food During Flood Relief",
      description:
        "In times of crisis, our volunteers step up to serve meals to those affected by flooding. This image captures the spirit of compassion as they provide nourishment and support to families in need.",
    },
    {
      img: "assets/img/m-home/G-2.jpg",
      title: "Empowering Futures: Volunteers Teaching Migrant Students",
      description:
        "Our dedicated volunteers are making a difference by providing education and support to migrant and underprivileged students.",
    },
    {
      img: "assets/img/m-home/G-3.jpg",
      title: "Compassion in Crisis: Serving Food to Flood-Trapped Families",
      description:
        "In the face of adversity, our volunteers are on the front lines, delivering meals to families fully trapped by floodwaters.",
    },
    {
      img: "assets/img/m-home/G-4.jpg",
      title: "Growing Together: Tree Plantation with Young Students",
      description:
        "Our volunteers are nurturing the environment by engaging young students in tree plantation activities.",
    },
    {
      img: "assets/img/m-home/G-5.jpg",
      title:
        "Nourishing Little Hearts: Volunteers Providing Essential Nutrients",
      description:
        "Our dedicated volunteers are on a mission to serve essential nutrients to underprivileged children. This image captures the joy and gratitude of young faces as they receive nutritious meals designed to support their growth and development",
    },
    {
      img: "assets/img/m-home/G-6.jpg",
      title: "Swift Response: Emergency Ambulance Service in Action",
      description:
        "This image showcases our dedicated team providing essential ambulance services during emergencies. With a commitment to saving lives, our volunteers are always ready to respond swiftly, ensuring that those in need receive immediate medical attention.",
    },
    {
      img: "assets/img/m-home/G-7.jpg",
      title: "Empowering Strength: Girls Training in Self-Defense",
      description:
        "This image captures the determination and spirit of young girls as they engage in self-defense training. Our dedicated volunteers are teaching essential martial arts skills, empowering these girls to build confidence and resilience. By equipping them with self-defense techniques.",
    },
    {
      img: "assets/img/m-home/G-8.jpg",
      title: "Courageous Hearts: Women Volunteers Donating Blood",
      description:
        "This powerful image showcases our incredible women volunteers coming together to donate blood, embodying the spirit of compassion and community service. Their selfless act of giving not only saves lives but also inspires others to contribute to this vital cause. ",
    },
    {
      img: "assets/img/m-home/G-9.jpg",
      title:
        "Inauguration of Free Sanitary Napkin Service: Empowering Women in Emergencies",
      description:
        "This image captures the moment of inauguration for our initiative to provide free sanitary napkins in public toilets, ensuring that women have access to essential hygiene products in times of need.",
    },
  ];

  return (
    <main className="main">
      <Carousel bannersItems={bannersItems} />

      {/* Services Section */}
      <Service
        serviceHeader="Share Your Hands"
        description="Are you passionate about making a difference in the lives of others? At Mallabhum Prayas, we believe that every individual has the power to create positive change. As a dedicated NGO focused on various social development activities, we invite you to share your hands and join our mission to uplift communities and empower individuals."
        services={shareYourHands}
      />

      <RecoverySection
        counters={counters}
        title="Turning Dreams Into Possibility"
      />
      <Service
        serviceHeader="Our Services"
        description="At Mallabhum Prayas, we are a dedicated volunteer organization committed to uplifting our community and empowering individuals through collective action and support. Our mission is to create positive change by harnessing the power of volunteers who share a passion for service and social impact."
        services={services}
      />

      {/* About Section */}

      <About />

      <MissionSection />

      {/* Portfolio Section */}

      <Portfolio
        portfolioHeader="Our Gallery"
        description="Our photo gallery is a visual representation of our journey and the
    impactful moments we've shared as a community. Each image tells a story,
    capturing the essence of our initiatives, the smiles of those we've helped,
    and the spirit of togetherness that defines us. From community events to
    relief efforts, these photographs reflect our commitment to making a
    difference and the bonds we've forged along the way. We invite you to
    explore our gallery and witness the transformation that has taken place
    since our inception in 2017."
        portfolioImage={portfolioImage}
      />
      {/* <iframe
        src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fakshay.manna.37%2Fposts%2Fpfbid02QcMhpEb8e7xC2qPH8aCmydBzNz2xF9Yh86wBcNxsfSfFEmj3Zdto35AoFA3mcpZul&show_text=true&width=500"
        width="500"
        height="250"
        style={{ border: "none", overflow: "hidden" }}
        scrolling="no"
        frameBorder="0"
        allowFullScreen={true}
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
      /> */}
      {/* BloodDonation Section */}
      <BloodDonation />

      {/* Testimonials Section */}
      <Testimonials />
    </main>
  );
};

export default Home;
